'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$() {
  this.aDm = null;
  this.aDn = false;
}
export { $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ as $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ };
$p = $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$;
/** @constructor */
function $h_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$() {
}
export { $h_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ as $h_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ };
$h_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$.prototype = $p;
$p.aA = (function() {
  if ((!this.aDn)) {
    this.aDm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeUri$$anon$2(this);
    this.aDn = true;
  }
  return this.aDm;
});
var $d_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$, "app.data.OrganizationLogo$package$OrganizationLogoUri$", ({
  Er: 1,
  B: 1,
  C: 1,
  oK: 1
}));
export { $d_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ as $d_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ };
var $n_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$;
function $m_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$() {
  if ((!$n_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$)) {
    $n_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ = new $c_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$();
  }
  return $n_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$;
}
export { $m_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ as $m_Lapp_data_OrganizationLogo$package$OrganizationLogoUri$ };
//# sourceMappingURL=app.data.-Organization-Logo$package$-Organization-Logo-Uri$.js.map
